module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1054-2f6dedca72c38888cee18507b2e290c2.png";